import { render, staticRenderFns } from "./zhihu.vue?vue&type=template&id=766fe0a7&scoped=true"
import script from "./zhihu.vue?vue&type=script&lang=js"
export * from "./zhihu.vue?vue&type=script&lang=js"
import style0 from "./zhihu.vue?vue&type=style&index=0&id=766fe0a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766fe0a7",
  null
  
)

export default component.exports